module.exports = __webpack_public_path__ + "media/images/dashboard/bg-4c1ad293513e039a79ca00eb1ee1610b.jpg";